import React, { ReactNode } from 'react';
import { Skeleton } from 'antd';
import { AvatarProps as AvatarCopyProps } from 'antd/lib/skeleton/Avatar';

export type AvatarProps = AvatarCopyProps & {
  children?: ReactNode;
};

const ProSkeletonAvatar: React.FC<AvatarProps> = (props) => {
  const { children, ...resProps } = props;

  return <Skeleton.Avatar {...resProps}>{children}</Skeleton.Avatar>;
};

export default ProSkeletonAvatar;
